export const ENTITY_CARD_HOVER_GROUP_ID = 'entityCard';
